import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { FormInput } from 'Shared/components';
import { SelectOption } from 'QuoteApp/services/endpoints/GetConfig';

import { PriceCustomizerFormValues } from '../domain';
import styles from './styles.module.css';

type SemiMonthlySelectorType = {
  isLoading?: boolean;
  options: Array<SelectOption<string>>;
  onChange?: (value: string) => void;
};

export const SemiMonthlySelector: FC<SemiMonthlySelectorType> = ({
  isLoading,
  options,
  onChange,
}) => {
  const { handleBlur, setFieldValue, values } =
    useFormikContext<PriceCustomizerFormValues>();

  const handleChange = (selectedValue: string) => {
    setFieldValue('semiMonthlyDates', selectedValue);

    if (onChange) {
      onChange(selectedValue);
    }
  };

  const transformOptions = (
    options: Array<SelectOption<string>>
  ): { [value: string]: string } => {
    return options.reduce(
      (acc, option) => {
        acc[option.value] = option.label;
        return acc;
      },
      {} as { [value: string]: string }
    );
  };

  return (
    <FormInput
      data-testid="payflex-semimonthly"
      variant="selectAutocomplete"
      name="semiMonthlyDates"
      label="Payment date"
      value={values.semiMonthlyDates}
      disabled={isLoading}
      className={styles.semiMonthlySelector}
      options={transformOptions(options)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
